import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import MenuIcon from '../../icons/Menu'
import * as ROUTES from '../../constants/routes'
import DisplayFlex from '../StyledElems/DisplayFlex'
import {
  NavBar,
  IconWrapper,
  Title
//  Notifications,
//  UserInfo
} from './components'
import UserInfo from './UserInfo'
import MainMenu from './MainMenu'
import SubMenu from './SubMenu'
import Notifications from './Notifications'

const DisplayTitle = styled(DisplayFlex)`
  min-width: 200px;
  max-width: 200px;
`

const Menu = props => {
  const { module, active, title } = props
  const history = useHistory()
  const goToMainMenu = () => history.push(ROUTES.ROOT_PATH)

  return (
    <>
      <NavBar>
        <DisplayTitle alignItems="center">
          <IconWrapper>
            <MenuIcon onClick={goToMainMenu} />
          </IconWrapper>
          <Title>{title}</Title>
        </DisplayTitle>

        <MainMenu module={module} active={active} />

        <DisplayFlex alignItems="center">
          <Notifications />
          <UserInfo />
        </DisplayFlex>
      </NavBar>

      <SubMenu module={module} active={active} />
    </>
  )
}

Menu.propTypes = {
  module: PropTypes.string.isRequired,
  active: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default Menu
